(() => {
  const enhance = () => {
    const root = document.querySelector('[id^="Zunftberuf-"]');
    if (!root || root.dataset.berufeAzEnhanced === '1') return;

    const content = root.querySelector('[data-zb-content]');
    if (!content) return;

    const items = [...content.querySelectorAll('.zb-az-item')];
    if (!items.length) return;

    root.dataset.berufeAzEnhanced = '1';
    root.classList.add('zb--berufe-az');

    const normalize = (value = '') => value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

    const categories = {
      bau: 'Bau & Ausbau',
      metall: 'Metall & Präzision',
      holz: 'Holz & Werkstatt',
      textil: 'Textil & Leder',
      lebensmittel: 'Lebensmittel',
      glas: 'Glas & Keramik',
      instrumente: 'Instrumentenbau',
      medien: 'Medien & Gestaltung',
      technik: 'Technik & Fahrzeuge',
      service: 'Dienstleistung & Handel',
      weitere: 'Weitere Berufe'
    };

    const classify = (title) => {
      const t = normalize(title);
      if (/(orgel|geigen|violin|klavier|cembalo|instrument|bogenmacher|zupfinstrument|blasinstrument)/.test(t)) return 'instrumente';
      if (/(baecker|konditor|fleischer|metzger|brauer|maelzer|mueller|koch|kueche|lebensmittel|weinkuefer|winzer)/.test(t)) return 'lebensmittel';
      if (/(schneider|weber|faerber|textil|sattler|kuerschner|gerber|leder|schuh|modist|hut|polster|seiler|spinner|sticker|naeher|taeschner)/.test(t)) return 'textil';
      if (/(glas|keramik|toepfer|hafner|porzellan|ziegler|ziegel|emaille)/.test(t)) return 'glas';
      if (/(tischler|schreiner|drechsler|boettcher|kuefer|holz|bildschnitzer|spielzeugmacher|korbmacher|buerstenbinder)/.test(t)) return 'holz';
      if (/(elektr|mechatron|fahrzeug|karosserie|kfz|zweirad|maschinen|mechaniker|mechanik|information|anlagen|system|technologe|techniker|feinwerk|optiker|augenoptiker|hoerakust|uhrmacher)/.test(t)) return 'technik';
      if (/(schmied|schlosser|goldschmied|silber|metall|giess|glockengiesser|guertler|kupfer|messerschmied|plattner|klempner|graveur|zinn|blechner|spengler)/.test(t)) return 'metall';
      if (/(maurer|dachdecker|zimmermann|zimmerer|steinmetz|geruest|strassen|bau|stuck|fliesen|bodenleger|maler|tuencher|lackierer|putzer|brunnenbauer|ofenbauer|kamin)/.test(t)) return 'bau';
      if (/(druck|buchbinder|buchdruck|fotograf|medien|gestalter|typograf|schilder|vergolder|zeichner)/.test(t)) return 'medien';
      if (/(friseur|barbier|bader|verkaeufer|kaufmann|hotel|gastwirt|service|florist|gaertner|bestatter|handel)/.test(t)) return 'service';
      return 'weitere';
    };

    const categoryCounts = new Map();
    let heritageCount = 0;

    items.forEach((item) => {
      const title = item.querySelector('strong')?.textContent.trim() || item.textContent.trim();
      const links = [...item.querySelectorAll('a')];
      const category = classify(title);
      const heritage = links.some((link) => {
        const label = normalize(link.textContent);
        const href = link.getAttribute('href') || '';
        return /(berufsgeschichte|geschichte|historisch|tradition)/.test(label) || /geschichte-des-|zunftlexikon/i.test(href);
      });
      const focus = heritage ? 'heritage' : 'modern';
      if (heritage) heritageCount += 1;

      item.dataset.azTitle = title;
      item.dataset.azCategory = category;
      item.dataset.azFocus = focus;
      item.dataset.azSearch = normalize(`${title} ${item.textContent} ${categories[category]}`);
      categoryCounts.set(category, (categoryCounts.get(category) || 0) + 1);

      if (!item.querySelector('.zb-az-badges')) {
        const badges = document.createElement('div');
        badges.className = 'zb-az-badges';
        badges.innerHTML = `<span>${categories[category]}</span><span>${heritage ? 'Historisch vertieft' : 'Modernes Berufsprofil'}</span>`;
        const titleNode = item.querySelector('strong');
        if (titleNode) titleNode.insertAdjacentElement('afterend', badges);
        else item.prepend(badges);
      }

      links.forEach((link) => {
        const label = normalize(link.textContent);
        link.classList.add('zb-az-card-link');
        if (/ausbildung/.test(label)) link.classList.add('zb-az-card-link--training');
        else if (/(wissenstest|quiz|test)/.test(label)) link.classList.add('zb-az-card-link--quiz');
        else link.classList.add('zb-az-card-link--primary');
      });
    });

    const letterHeadings = [...content.querySelectorAll('h2')].filter((heading) => /^[A-ZÄÖÜ]$/.test(heading.textContent.trim()));
    const pairs = letterHeadings.map((heading) => {
      const list = heading.nextElementSibling;
      if (!list || !list.matches('ul.zb-az-list')) return null;
      heading.classList.add('zb-az-letter-heading');
      return { heading, list, letter: heading.textContent.trim() };
    }).filter(Boolean);

    let groups = content.querySelector('.zb-az-groups');
    if (!groups && pairs.length) {
      groups = document.createElement('div');
      groups.className = 'zb-az-groups';
      pairs[0].heading.parentNode.insertBefore(groups, pairs[0].heading);
      pairs.forEach(({ heading, list }) => {
        groups.append(heading, list);
      });
    }

    const jump = content.querySelector('.zb-az-jump');
    const tools = document.createElement('section');
    tools.className = 'zb-az-tools';
    tools.setAttribute('aria-labelledby', 'zb-az-tools-title');
    tools.innerHTML = `
      <div class="zb-az-tools__head">
        <div>
          <p class="zb-az-tools__kicker">Berufsverzeichnis durchsuchen</p>
          <h2 id="zb-az-tools-title">${items.length} Berufe schneller finden</h2>
          <p>Suche direkt nach einem Beruf oder grenze das Lexikon nach Fachbereich und Profiltyp ein. Alle bestehenden Berufs-, Ausbildungs- und Wissenstestseiten bleiben direkt erreichbar.</p>
        </div>
        <div class="zb-az-stats" aria-label="Umfang des Berufsverzeichnisses">
          <span><strong>${items.length}</strong> Profile</span>
          <span><strong>${heritageCount}</strong> historisch vertieft</span>
          <span><strong>${items.length - heritageCount}</strong> moderne Profile</span>
        </div>
      </div>
      <div class="zb-az-controls">
        <label class="zb-az-search">
          <span>Beruf suchen</span>
          <div><span aria-hidden="true">⌕</span><input type="search" data-az-search autocomplete="off" placeholder="z. B. Schmied, Bäcker, Uhrmacher"></div>
        </label>
        <label class="zb-az-sort">
          <span>Sortierung</span>
          <select data-az-sort><option value="asc">A–Z</option><option value="desc">Z–A</option></select>
        </label>
      </div>
      <div class="zb-az-filter-block">
        <p>Profiltyp</p>
        <div class="zb-az-filter-row" data-az-focus-filters>
          <button type="button" data-value="all" aria-pressed="true">Alle Profile</button>
          <button type="button" data-value="heritage" aria-pressed="false">Historisch vertieft</button>
          <button type="button" data-value="modern" aria-pressed="false">Moderne Berufsprofile</button>
        </div>
      </div>
      <div class="zb-az-filter-block">
        <p>Fachbereich</p>
        <div class="zb-az-filter-row zb-az-filter-row--categories" data-az-category-filters></div>
      </div>
      <div class="zb-az-results-bar">
        <strong data-az-result-count role="status" aria-live="polite">${items.length} von ${items.length} Berufen</strong>
        <button type="button" data-az-reset>Filter zurücksetzen</button>
      </div>
      <div class="zb-az-empty" data-az-empty hidden><strong>Kein passender Beruf gefunden.</strong><span>Versuche einen anderen Suchbegriff oder setze die Filter zurück.</span></div>
    `;

    const insertTarget = jump || groups || pairs[0]?.heading || content.firstElementChild;
    if (insertTarget) insertTarget.parentNode.insertBefore(tools, insertTarget);
    else content.appendChild(tools);

    const categoryFilters = tools.querySelector('[data-az-category-filters]');
    const allCategory = document.createElement('button');
    allCategory.type = 'button';
    allCategory.dataset.value = 'all';
    allCategory.setAttribute('aria-pressed', 'true');
    allCategory.textContent = `Alle Fachbereiche (${items.length})`;
    categoryFilters.appendChild(allCategory);

    Object.entries(categories).forEach(([key, label]) => {
      const count = categoryCounts.get(key) || 0;
      if (!count) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.value = key;
      button.setAttribute('aria-pressed', 'false');
      button.textContent = `${label} (${count})`;
      categoryFilters.appendChild(button);
    });

    const state = { query: '', focus: 'all', category: 'all', sort: 'asc' };
    const searchInput = tools.querySelector('[data-az-search]');
    const sortSelect = tools.querySelector('[data-az-sort]');
    const resultCount = tools.querySelector('[data-az-result-count]');
    const empty = tools.querySelector('[data-az-empty]');
    const focusFilter = tools.querySelector('[data-az-focus-filters]');

    const sortGroups = () => {
      if (!groups || !pairs.length) return;
      const sorted = [...pairs].sort((a, b) => a.letter.localeCompare(b.letter, 'de'));
      if (state.sort === 'desc') sorted.reverse();
      sorted.forEach(({ heading, list }) => groups.append(heading, list));
    };

    const syncButtons = (container, active) => {
      container?.querySelectorAll('button[data-value]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.value === active));
      });
    };

    const updateAlphabet = () => {
      if (!jump) return;
      jump.querySelectorAll('a[href^="#"]').forEach((link) => {
        const id = decodeURIComponent(link.getAttribute('href').slice(1));
        const heading = document.getElementById(id);
        const unavailable = !heading || heading.hidden;
        link.classList.toggle('is-unavailable', unavailable);
        link.setAttribute('aria-disabled', String(unavailable));
        if (unavailable) link.setAttribute('tabindex', '-1');
        else link.removeAttribute('tabindex');
      });
    };

    const applyFilters = () => {
      let visible = 0;
      items.forEach((item) => {
        const queryMatch = !state.query || item.dataset.azSearch.includes(state.query);
        const focusMatch = state.focus === 'all' || item.dataset.azFocus === state.focus;
        const categoryMatch = state.category === 'all' || item.dataset.azCategory === state.category;
        const show = queryMatch && focusMatch && categoryMatch;
        item.hidden = !show;
        if (show) visible += 1;
      });

      pairs.forEach(({ heading, list }) => {
        const hasVisible = [...list.querySelectorAll('.zb-az-item')].some((item) => !item.hidden);
        heading.hidden = !hasVisible;
        list.hidden = !hasVisible;
      });

      resultCount.textContent = `${visible} von ${items.length} Berufen`;
      empty.hidden = visible !== 0;
      syncButtons(focusFilter, state.focus);
      syncButtons(categoryFilters, state.category);
      updateAlphabet();
    };

    searchInput.addEventListener('input', () => {
      state.query = normalize(searchInput.value);
      applyFilters();
    });

    sortSelect.addEventListener('change', () => {
      state.sort = sortSelect.value;
      sortGroups();
      updateAlphabet();
    });

    focusFilter.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-value]');
      if (!button) return;
      state.focus = button.dataset.value;
      applyFilters();
    });

    categoryFilters.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-value]');
      if (!button) return;
      state.category = button.dataset.value;
      applyFilters();
    });

    tools.querySelector('[data-az-reset]').addEventListener('click', () => {
      state.query = '';
      state.focus = 'all';
      state.category = 'all';
      state.sort = 'asc';
      searchInput.value = '';
      sortSelect.value = 'asc';
      sortGroups();
      applyFilters();
      searchInput.focus();
    });

    jump?.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      if (link.classList.contains('is-unavailable')) {
        event.preventDefault();
        return;
      }
      const id = decodeURIComponent(link.getAttribute('href').slice(1));
      const target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', `#${encodeURIComponent(id)}`);
    });

    const heroLead = root.querySelector('.zb-hero__lead p');
    if (heroLead && /\d+/.test(heroLead.textContent)) {
      heroLead.textContent = `${items.length} Handwerks- und Traditionsberufe mit Berufsgeschichte, Ausbildungsweg und anspruchsvollem Wissenstest.`;
    }

    sortGroups();
    applyFilters();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
})();